skrilla.controller('reconcileAffiliateClaimsModalCtrl', function ($scope, cacheService, modalService, searchService, validationService, currencyService) {
    $scope.reconcilliation = {};
    $scope.validate = {}

    $scope.claims = cacheService.getObjectOrElse("selectedAffiliateClaims", function noAffiliatesSelected(){
        modalService.dismissAll();
        alert("No affiliate claims selected!");
    })
    $scope.address =  cacheService.getObject("affiliateAddress")


    $scope.amountToReconcile = 0;
    $scope.claims.forEach(function(claim){
        $scope.amountToReconcile += claim.ownerAmount;
    })

    $scope.reconcile = function(){
        var valid = true;
        if(!$scope.transferSKR){
            $scope.reconcilliation.amount = null;
        }
        else if(validationService.isEmpty($scope.reconcilliation.amount)){
            $scope.validate.amount = "Must enter a valid amount to send"
            valid = false;
        }
        else{
            $scope.reconcilliation.amount = $scope.reconcilliation.amount * currencyService.getCurrencyAmount("SKR");
        }
        if(valid === true) {
            modalService.confirm("Are you sure you'd like to reconcile these claims?", function(){
                    $scope.validate.amount = ""
                    $scope.reconcilliation.ids = $scope.claims.map(function (claim) {
                        return claim.id
                    });
                    searchService.put("affiliates/" + $scope.claims[0].ownerId + "/claims/reconcile", $scope.reconcilliation, "Successfully reconciled claims!").then(function (response) {
                        modalService.dismissAll();
                    });
            });
        }
    }

});